// extracted by mini-css-extract-plugin
export default {"evolutionTooltipContent":"yXSr_IqN","top":"q9Xu8rzn","left":"Pc4v6PF1","right":"Q0ztgKz4","bottom":"mpXpoDlg","title":"BxZGvIiv","date":"clPiYZ_v","learn":"scXqJdqU"};